// Hooks
import { useOnboardingContext } from 'hooks';
// Components
import FullScreenStepperModal from 'components/common3/FullScreenStepperModal/FullScreenStepperModal';
import StreamingInitialStep from './StreamingInitialStep/StreamingInitialStep';
import CreateInterviewSetup from './CreateInterviewSetup/CreateInterviewSetup';
import HostInterviewSetup from './HostInterviewSetup/HostInterviewSetup';

const StreamingSetup = () => {
  const {
    showStreamingSetupModal,
    showCreateInterviewModal,
    showHostCalendarModal,
    setShowStreamingSetupModal,
  } = useOnboardingContext();

  const handleClose = () => {
    setShowStreamingSetupModal(false);
  };

  return (
    <FullScreenStepperModal
      title="STREAMING AND MEDIA"
      open={showStreamingSetupModal}
      onClose={handleClose}
    >
      <>
        <StreamingInitialStep />
        {showCreateInterviewModal && <CreateInterviewSetup />}
        {showHostCalendarModal && <HostInterviewSetup />}
      </>
    </FullScreenStepperModal>
  );
};

export default StreamingSetup;
